import React from 'react';
import { BaseResponsiveSearchCard } from '../Base/Responsive';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import { GrayUIText, Title, BottomContent } from '../Base/styles';
import {
  BoxConditionIcon,
  TruckIcon,
  MapMarkerIcon,
  PhoneIcon,
} from '../../../../assets';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[3].rem} ${theme.spacings[2].rem};
`;

export const AssetForSaleResponsiveSearchCard: React.FC<
  SearchCard<'AssetForSale'>
> = ({
  title,
  price,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseResponsiveSearchCard {...props}>
      <Content>
        <Title>{title}</Title>

        <Pill
          backgroundColor={theme.colors.neutrals.transparentGrays[6]}
          icon={PhoneIcon}
        >
          {data.pillText}
        </Pill>

        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              (condition as string).length < 15 && (
                <>
                  <TruckIcon width={16} fill={theme.colors.primary.graysGray} />
                  Delivery
                </>
              )
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseResponsiveSearchCard>
  );
};
